import { Observable } from 'rxjs';
import { ApiModule } from 'api';
import { Environment } from 'types';
import { BaseUrls } from '../../module/baseUrl';

enum Types {
  SearchDone = 'search_done',
  SearchResult = 'search_result',
  SearchError = 'search_error',
  Technical = 'technical',
}

interface SSEEvent {
  data: boolean | string | number | object | null;
  type: Types;
}

const observeSearchEvents = (roomId: string): Observable<SSEEvent> => {
  const authKey = ApiModule.getMLAuthKey();

  const path = `/sse?authorization=${authKey}&fp-room-id=${roomId}`;
  const url = `${BaseUrls.mlApiUrl}${path}`;

  return new Observable<SSEEvent>((subscriber) => {
    const eventSource = new EventSource(url);

    eventSource.onopen = () => {};

    eventSource.addEventListener(Types.Technical, (event) => {
      subscriber.next({ data: event.data, type: Types.Technical });
    });

    eventSource.addEventListener(Types.SearchDone, (event) => {
      subscriber.next({ data: true, type: Types.SearchDone });
      eventSource.close();
      subscriber.complete();
    });

    eventSource.addEventListener(Types.SearchResult, (event) => {
      try {
        const parsed = JSON.parse(event.data)[0];
        subscriber.next({ data: parsed, type: Types.SearchResult });
      } catch (error) {
        subscriber.error('Error parsing SSE data');
      }
    });

    eventSource.onerror = (error) => {
      subscriber.error('SSE error');
      eventSource.close();
    };

    return () => {
      eventSource.close();
    };
  });
};

export const SSEHotels = { observeSearchEvents, Types };
